export default __webpack_public_path__ + "static/media/FotoCEDULA.e7215991.svg";